export default __webpack_public_path__ + "static/section-image-2-3199c7cdbe25c6f657afdbf145b299a1.jpg";